import { render, staticRenderFns } from "./GeneraliImpianto.vue?vue&type=template&id=30e68807&"
import script from "./GeneraliImpianto.vue?vue&type=script&lang=js&"
export * from "./GeneraliImpianto.vue?vue&type=script&lang=js&"
import style0 from "./GeneraliImpianto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports